<template>
  <nuxt-child />
</template>

<script>
export default {
  head() {
    return {
      title: '我的消费卡'
    }
  }
}
</script>
